import { render, staticRenderFns } from "./PageWeek.vue?vue&type=template&id=59d06469"
import script from "./PageWeek.vue?vue&type=script&lang=js"
export * from "./PageWeek.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports